import http from "../http-common";

class QuestionnaireDataService {

  getAll() {
    return http.get("/questionnaire");
  }

  get(id) {
    return http.get(`/questionnaire/${id}`);
  }

  create(data) {
    return http.post("/questionnaire", data);
  }

  update(id, data) {
    return http.put(`/questionnaire/questions/${id}`, data);
  }

  delete(id) {
    return http.delete(`/questionnaire/${id}`);
  }

  deleteAll(id) {
    return http.delete(`/questionnaire/${id}`);
  }

}

export default new QuestionnaireDataService();